import ActionTypes from '../Data/ActionTypes';

export const getSubmissionStatusAction = ({
  submissionId,
  iFrameId,
  token,
}) => {
  return {
    type: ActionTypes.GET_SUBMISSION_STATUS,
    payload: {
      submissionId,
      iFrameId,
      token,
    },
  };
};

export const getAppointmentsAction = ({
  postcode,
  country,
  provider,
  appointmentBookingPage,
  locale,
}) => {
  return {
    type: ActionTypes.GET_APPOINTMENTS,
    payload: { postcode, country, provider, appointmentBookingPage, locale },
  };
};

export const getLeadStatusAction = ({ submissionId, token }) => {
  return {
    type: ActionTypes.GET_LEAD_STATUS,
    payload: { submissionId, token },
  };
};

export const stopLeadStatusPollAction = () => {
  return {
    type: ActionTypes.STOP_LEAD_STATUS_POLL,
  };
};

export const getClientApiLocationsAction = ({
  postcode,
  storeRadius,
  storeRadiusUnit,
}) => {
  return {
    type: ActionTypes.GET_CLIENT_API_LOCATIONS,
    payload: { postcode, storeRadius, storeRadiusUnit },
  };
};

export const getClientApiSlotsAction = ({
  location,
  locationStepKey,
  refresh,
}) => {
  return {
    type: ActionTypes.GET_CLIENT_API_SLOTS,
    payload: { location, locationStepKey, ...(refresh && { refresh: true }) },
  };
};

export const getClientApiSolarAction = () => {
  return { type: ActionTypes.GET_CLIENT_API_SOLAR };
};

export const getClientApiVerifyPotentialAction = () => {
  return { type: ActionTypes.GET_CLIENT_API_VERIFY_POTENTIAL };
};

export const checkSubscriptionMatchAction = () => {
  return { type: ActionTypes.CHECK_SUBSCRIPTION_MATCH };
};

export const cancelSubscriptionMatchCheckAction = () => {
  return { type: ActionTypes.CANCEL_SUBSCRIPTION_MATCH_CHECK };
};

// ReviewBooking gates this on selectIsBookingConfirmable; any new dispatcher
// must too.
export const submitClientApiBookingAction = ({ slot }) => {
  return {
    type: ActionTypes.SUBMIT_CLIENT_API_BOOKING,
    payload: { slot },
  };
};

export const reportClientApiBookingNotConfirmableAction = () => {
  return {
    type: ActionTypes.REPORT_CLIENT_API_BOOKING_NOT_CONFIRMABLE,
  };
};

export const reportClientApiFallThroughOutcomeAction = ({ reason }) => {
  return {
    type: ActionTypes.REPORT_CLIENT_API_FALL_THROUGH_OUTCOME,
    reason,
  };
};

export const refuseClientApiJourneyAction = () => {
  return {
    type: ActionTypes.REFUSE_CLIENT_API_JOURNEY,
  };
};

export const startClientApiInactivityTimerAction = () => {
  return {
    type: ActionTypes.START_CLIENT_API_INACTIVITY_TIMER,
  };
};

export const stopClientApiInactivityTimerAction = () => {
  return {
    type: ActionTypes.STOP_CLIENT_API_INACTIVITY_TIMER,
  };
};

export const clientApiUserActivityAction = () => {
  return {
    type: ActionTypes.CLIENT_API_USER_ACTIVITY,
  };
};

export const confirmClientApiStillPresentAction = () => {
  return {
    type: ActionTypes.CONFIRM_CLIENT_API_STILL_PRESENT,
  };
};

export const submitSelectAndConnectAction = ({ selectAndConnectPage }) => {
  return {
    type: ActionTypes.SUBMIT_SELECT_AND_CONNECT,
    payload: { selectAndConnectPage },
  };
};

export const clearSelectAndConnectNavigationBlocks = ({
  selectAndConnectPage,
}) => {
  return {
    type: ActionTypes.CLEAR_SELECT_AND_CONNECT_NAVIGATION_BLOCKS,
    payload: { selectAndConnectPage },
  };
};

export const getLegalStatementAction = ({
  subcategoryId,
  localeCode,
  supplierId,
  newsletters,
}) => {
  return {
    type: ActionTypes.GET_LEGAL_STATEMENT,
    payload: {
      subcategoryId,
      localeCode,
      supplierId,
      newsletters,
    },
  };
};

export const decryptCrmData = ({ payload }) => {
  return {
    type: ActionTypes.DECRYPT_CRM_DATA,
    payload: { payload },
  };
};

export const isDomainInternalSaga = ({ domain }) => {
  return {
    type: ActionTypes.IS_DOMAIN_INTERNAL,
    payload: { domain },
  };
};

export const getCustomerMatchesSaga = () => {
  return {
    type: ActionTypes.GET_CUSTOMER_MATCHES,
    payload: {},
  };
};

export const prepareSupplierMatchingSaga = () => {
  return {
    type: ActionTypes.PREPARE_SUPPLIER_MATCHING,
    payload: {},
  };
};

export const getSupplierCardLogosSaga = () => {
  return {
    type: ActionTypes.GET_SUPPLIER_CARD_LOGOS,
    payload: {},
  };
};

export const handleAnswerQuestionSideEffectsSaga = ({ componentId }) => {
  return {
    type: ActionTypes.HANDLE_ANSWER_QUESTION_SIDE_EFFECTS,
    payload: { componentId },
  };
};

export const getDynamicNewsletterSaga = ({
  visitorId,
  destinationPageNumber,
  fallbackNewsletter,
}) => {
  return {
    type: ActionTypes.GET_DYNAMIC_NEWSLETTER,
    payload: { visitorId, destinationPageNumber, fallbackNewsletter },
  };
};

export const getPlacePredictionsSaga = ({
  input,
  visitorId,
  regionCode,
  componentId,
  locationBias,
}) => {
  return {
    type: ActionTypes.GET_PLACE_PREDICTIONS,
    payload: { input, visitorId, regionCode, componentId, locationBias },
  };
};

export const handleGoogleAddressSelectedSaga = ({
  componentId,
  placeId,
  shouldPopulateUpcomingFields,
  inputValue,
  formId,
  iFrameId,
  visitorId,
}) => {
  return {
    type: ActionTypes.HANDLE_GOOGLE_ADDRESS_SELECTED,
    payload: {
      componentId,
      placeId,
      shouldPopulateUpcomingFields,
      inputValue,
      formId,
      iFrameId,
      visitorId,
    },
  };
};

export const handleZipcodeUpdatedSaga = ({
  componentId,
  postcode,
  country,
  formId,
  iFrameId,
}) => {
  return {
    type: ActionTypes.HANDLE_ZIP_CODE_PROVIDED,
    payload: {
      componentId,
      postcode,
      country,
      formId,
      iFrameId,
    },
  };
};

export const populateFormFieldSaga = ({
  countryCode,
  value,
  iFrameId,
  formId,
  component,
}) => {
  return {
    type: ActionTypes.POPULATE_FORM_FIELD,
    payload: { countryCode, value, iFrameId, formId, component },
  };
};
